import { useRouter } from 'next/router';
import type { FC, PropsWithChildren } from 'react';

import AuthDialog from '@/components/CandidateAuth/AuthDialog';
import { AuthPageEnum } from '@/components/CandidateAuth/AuthEnum';
import { useAuthDialogStore } from '@/stores/useAuthDialogStore';

import Footer from './Footer';
import type { Theme } from './Header/Header';
import Header from './Header/Header';

type Props = {
  theme?: Theme;
};

const Layout: FC<PropsWithChildren<Props>> = ({ children, theme = 'dark' }) => {
  const { isOpen, defaultPage, setIsOpen } = useAuthDialogStore();
  const router = useRouter();
  return (
    <>
      <Header theme={theme} />
      <div className="flex flex-1 flex-col">{children}</div>
      <Footer />
      <AuthDialog
        key={defaultPage}
        defaultPage={defaultPage ?? AuthPageEnum.LOGIN_PROVIDERS}
        dialogContentProps={{ onCloseAutoFocus: (e) => e.preventDefault() }}
        dialogProps={{ open: isOpen, onOpenChange: setIsOpen }}
        onSuccess={() => router.push('/builder')}
        googleCallbackUrl="/builder"
      >
        <span />
      </AuthDialog>
    </>
  );
};

export default Layout;
